<script lang="ts">
      import type { Snippet } from 'svelte'

      type BlockWidth = {
            children?: Snippet
            width?: 'normal' | 'wide' | 'full'
            class?: string
      }

      let { children = undefined, width = 'normal', class: className = "p-2" }: BlockWidth = $props()
</script>

<div class="render-block w-full {width} {className} mx-auto">
      {@render children?.()}
</div>

<style lang="postcss">
      .render-block:global(.normal) {
            @apply md:max-w-screen-md lg:max-w-screen-lg;
      }

      .render-block:global(.wide) {
            @apply md:max-w-screen-lg lg:max-w-screen-3xl;
      }

      .render-block:global(.full) {
            @apply max-w-full;
      }

      .render-block:last-of-type{
        /*@apply mb-12 md:mb-32;*/
      }
</style>
